module.exports = __webpack_public_path__ + "static/img/pur_3.b0e84db.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/pur_3.png
// module id = 1D58
// module chunks = 1